/*
 * @Description:
 * @Author: WangYuhan
 * @Date: 2023-03-06 11:00:06
 * @LastEditTime: 2023-03-10 16:01:08
 * @LastEditors: WangYuhan
 */
// 引入api请求方法
import { waybillRobotLogPageList } from '@/api/waybill';

/**
 *
 * @update 2019年10月27日
 * */

const state = {
  // 接口调用参数
  postParams: {
    page: 1,
    size: 10,
  },
  // 列表data数据
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '事件',
        prop: 'eventName',
        width: 120,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-eventName',
      },
      {
        label: '时间',
        prop: 'sendTime',
        width: 110,
        checked: 1,
        sortable: true,
      },
      {
        label: '微信通知对象',
        prop: 'sendType',
        width: 80,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-sendType',
      },
      {
        label: '微信通知结果',
        prop: 'sendStatus',
        width: 80,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-sendStatus',
      },
      {
        label: '详细内容',
        prop: 'sendMsg',
        width: 240,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-sendMsg',
      },
    ],
    total: 0,
  },
  waybillNo: '',
};

// getters
const getters = {};

// actions
const actions = {
  // 获取列表数据
  getList: async (context, apiUrl) => {
    // 默认请求地址 是URL地址 例如 /resource/employee/index  跟路由匹配
    const { data } = await waybillRobotLogPageList(
      Object.assign({}, context.state.postParams, { waybillNo: context.state.waybillNo }),
    );
    context.commit(
      'updateListData',
      Object.assign({}, context.state.listData, { list: data.records }, { total: data.total }),
    );
  },
};

// mutations
const mutations = {
  // 更新data数据
  updateListData(state, payload) {
    state.listData = payload;
  },
  // 更新列表表头数据
  updateEditTableList(state, payload) {
    state.listData.tableHeadList = payload;
  },
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },

  // 更新参数waybillNo
  updateWaybillNo(state, payload) {
    state.waybillNo = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
